export default class BumperballLocationHandler {
    static BOCHOLT_VALUE  = 'Bocholt';
    static CHILDREN_VALUE = 'Ballen voor kinderen (7 \u2013 13 jaar)';
    static ADULTS_VALUE   = 'Ballen voor volwassenen (vanaf 10 jaar)';


    /** Private fields  **/
    #locationSelect;
    #typeSelect;
    #lastLocation = null;
    #boundHandler;

    constructor() {
        this.#locationSelect = document.getElementById('bumperball_location');
        this.#typeSelect     = document.getElementById('bumperball_type');

        if (!this.#locationSelect || !this.#typeSelect) {
            console.warn('BumperballLocationHandler: required select elements not found in DOM.');
            return;
        }

        this.#boundHandler = () => this.#applyRestriction();
        this.#locationSelect.addEventListener('change', this.#boundHandler);
        this.#applyRestriction();
    }

    /**
     * Applies type restrictions based on the currently selected location.
     * Bocholt allows both adult and children balls; all other locations only allow adults.
     * Skips processing if the location value has not changed since last call.
     */
    #applyRestriction() {
        const currentLocation = this.#locationSelect.value;

        if (currentLocation === this.#lastLocation) return;
        this.#lastLocation = currentLocation;

        const isBocholt   = currentLocation === BumperballLocationHandler.BOCHOLT_VALUE;
        const adultsOption = this.#findOption(BumperballLocationHandler.ADULTS_VALUE);

        Array.from(this.#typeSelect.options).forEach((option) => {
            const isAdults = option.value === BumperballLocationHandler.ADULTS_VALUE;
            const show     = isBocholt || isAdults;

            option.disabled = !show;
            option.hidden   = !show;
        });

        if (!isBocholt && this.#typeSelect.value !== BumperballLocationHandler.ADULTS_VALUE) {
            if (adultsOption) {
                this.#typeSelect.value = BumperballLocationHandler.ADULTS_VALUE;
            } else {
                console.warn('BumperballLocationHandler: adults option not found in bumperball_type select.');
            }
        }
    }

    /**
     * Returns the <option> element matching the given value, or null if not found.
     * @param {string} value
     * @returns {HTMLOptionElement|null}
     */
    #findOption(value) {
        return Array.from(this.#typeSelect.options).find((o) => o.value === value) ?? null;
    }

    /**
     * Removes the change event listener and resets internal state.
     * Call this when the component is no longer needed to avoid memory leaks.
     */
    destroy() {
        if (this.#locationSelect && this.#boundHandler) {
            this.#locationSelect.removeEventListener('change', this.#boundHandler);
        }
        this.#lastLocation = null;
    }
}